import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import BySubject from './bySubject';

var ByPageView = /*#__PURE__*/function (_BySubject) {
  _inherits(ByPageView, _BySubject);

  var _super = _createSuper(ByPageView);

  function ByPageView() {
    var _this;

    _classCallCheck(this, ByPageView);

    _this = _super.call(this);
    _this.dirtyGuard = Symbol('__dirty__');
    _this.beforeUrl = '';
    return _this;
  }

  _createClass(ByPageView, [{
    key: "execute",
    value: function execute(opts) {
      // window.addEventListener(
      //   'beforeunload',
      //   () => {
      //     // TODO: sendBeacon 待测试
      //     // navigator.sendBeacon(url, param);
      //     this.notify('disappear');
      //   },
      //   false,
      // );
      this.opts = opts;
      this.firstIntoPage();
      this.proxyHistoryState();
    }
  }, {
    key: "firstIntoPage",
    value: function firstIntoPage() {
      var _this2 = this;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          _this2.notify('appear');
        });
      } else {
        this.notify('appear');
      }
    }
    /*
      popstate 并不能监听 pushState 和 replaceState
      目前站点很多跳转是通过 location.href 实现的
      该代码用来代替
      window.addEventListener('popstate', listener);
      const pushUrl = (href) => {
        history.pushState({}, '', href);
        window.dispatchEvent(new Event('popstate'));
      };
    */

  }, {
    key: "proxyHistoryState",
    value: function proxyHistoryState() {
      var RESET_LIST = ['pushState', 'replaceState', 'forward', 'go', 'back'];
      var self = this;
      RESET_LIST.forEach(function (item) {
        if (!window.history[item][self.dirtyGuard]) {
          var mirrorState = window.history[item];

          window.history[item] = function proxyState() {
            // self.notify('disappear');
            setTimeout(function () {
              self.notify('appear');
            });

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            mirrorState.apply(window.history, args);
          };

          window.history[item][self.dirtyGuard] = true;
        }
      });
    }
  }, {
    key: "notify",
    value: function notify(page_act) {
      var href = window.location.href;
      if (this.beforeUrl === href) return;
      this.beforeUrl = href;
      this.notifyObservers(_objectSpread({
        page_act: page_act,
        dt: undefined
      }, this.opts));
    }
  }]);

  return ByPageView;
}(BySubject);

export { ByPageView as default };